<template>
  <a-card :bordered="false" v-if="visible">
    <a-modal :title="moduleTitle" :width="500" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form :form="form">
        <a-form-item
          required
          label="旧密码"
          :labelCol="{ lg: { span: 7 }, sm: { span: 7 } }"
          :wrapperCol="{ lg: { span: 25 }, sm: { span: 17 } }"
        >
          <a-input
            size="large"
            type="password"
            autocomplete="false"
            placeholder="请输入旧密码"
            v-decorator="[
              'oldPassword',
              { rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur' },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item
          required
          label="新密码"
          :labelCol="{ lg: { span: 7 }, sm: { span: 7 } }"
          :wrapperCol="{ lg: { span: 25 }, sm: { span: 17 } }"
        >
          <a-input
            size="large"
            type="password"
            autocomplete="false"
            placeholder="请输入新密码"
            v-decorator="[
              'newPassword',
              { rules: [{ required: true, message: '请输入新密码' }], validateTrigger: 'blur' },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item
          required
          label="再次确认新密码"
          :labelCol="{ lg: { span: 7 }, sm: { span: 7 } }"
          :wrapperCol="{ lg: { span: 25 }, sm: { span: 17 } }"
        >
          <a-input
            size="large"
            type="password"
            autocomplete="false"
            placeholder="请再次输入新密码"
            v-decorator="[
              'repeatNewPassword',
              { rules: [{ required: true, message: '请再次确认密码' }], validateTrigger: 'blur' },
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item class="center">
          <a-button size="large" type="primary" htmlType="submit" @click="handleSubmit">确定</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import { mapActions } from 'vuex'
// const defaultFormData = {
//   oldPassword: '',
//   newPassword: '',
//   repeatNewPassword: ''
// }
export default {
  name: 'Password',
  data() {
    return {
      moduleTitle: '修改密码',
      visible: false,
      form: this.$form.createForm(this),
      // form:  form: this.$form.createForm(this
      // list: []
    }
  },

  mounted() {
    // this.loadData()
  },
  methods: {
    // async loadData() {
    //   // this.list = await this.$http.get(process.env.VUE_APP_API_BASE_MODULE + '/sysUser/o-info')
    // },
    ...mapActions(['Logout']),
    show() {
      this.visible = true
      const {
        form: { setFieldsValue },
      } = this
      setFieldsValue({
        oldPassword: '',
        newPassword: '',
        repeatNewPassword: '',
      })
    },
    handleCancel() {
      this.visible = false
    },
    async handleSubmit(e) {
      const {
        form: { validateFields },
      } = this
      const validateFieldsKey = ['oldPassword', 'newPassword', 'repeatNewPassword']
      console.log('form', this.form)
      validateFields(validateFieldsKey, { force: true }, async (err, values) => {
        if (!err) {
          if (values.newPassword !== values.repeatNewPassword) {
            this.$message.error('两次输入密码不一致')
            return
          }
          const rz = await this.$http.post('/p/web/auth/reset/password', values)
          if (rz) {
            this.Logout()
            console.log('rz', rz)
            this.$message.success('修改成功，请重新登录')
            setTimeout(() => {
              this.$router.push({ name: 'login' })
            }, 2000)
          }
        } else {
        }
      })

      // e.preventDefault()
      // const {
      //   form: { validateFields }
      // } = this
      // const validateFieldsKey = ['oldPass', 'newPass', 'repeatNewPass']
      // validateFields(validateFieldsKey, { force: true }, async (err, values) => {
      //   if (!err) {
      //   } else {
      //   }
      // })
    },
  },
}
</script>
<style scoped>
.center {
  text-align: center;
}
</style>
